(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const currentHost = window.location.hostname.replace(/^www\./, '');
    const leaveSiteModalSelector = "#modal-leave-site-confirmation";
    const leaveSiteModal = document.querySelector(leaveSiteModalSelector);
    const hasLeaveSiteModal = leaveSiteModal !== null;
    const whitelistedDomains = (leaveSiteModal?.getAttribute("data-whitelisted-domains") || "")
      .split(/\r?\n/)
      .map(domain => domain.trim().toLowerCase())
      .filter(Boolean);

    const isWhitelistedDomain = linkHost => whitelistedDomains.some(domain => {
      if (domain.startsWith("*.")) {
        return linkHost.endsWith(domain.substring(1));
      }

      return linkHost === domain;
    });

    document.querySelectorAll('a[href^="http"]:not([data-no-speed-bump-modal="true" i])').forEach(link => {
      let linkHostname;

      try {
        linkHostname = new URL(link.href).hostname.toLowerCase();
      }
      catch {
        return;
      }

      const linkHost = linkHostname.replace(/^www\./, '');

      if (linkHost !== currentHost) {
        const authoredTargetBehavior = (link.getAttribute("data-external-link-target") || "").toLowerCase();

        if (authoredTargetBehavior === "same-tab") {
          link.removeAttribute("target");
        }
        else if (authoredTargetBehavior === "new-tab") {
          link.setAttribute("target", "_blank");
        }
        else if (!link.hasAttribute("target")) {
          link.setAttribute("target", "_blank");
        }

        if (link.getAttribute("target") === "_blank" && !link.hasAttribute("rel")) {
          link.setAttribute("rel", "noopener noreferrer");
        }

        if (isWhitelistedDomain(linkHostname)) {
          return;
        }

        if (hasLeaveSiteModal) {
          if (!link.hasAttribute("data-toggle")) {
            link.setAttribute("data-toggle", "modal");
          }

          if (!link.hasAttribute("data-target")) {
            link.setAttribute("data-target", leaveSiteModalSelector);
          }

          if (!link.classList.contains("external-site-link")) {
            link.classList.add("external-site-link");
          }
        }
      }
    });
  });
})();
